// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileBulkFollowModal-cls1___b018a5164d4e561df67","cls2":"ProfileBulkFollowModal-cls2___6bc8eab2d09bf5872f4 ProfileBulkFollowModal-cls1___b018a5164d4e561df67"};